import splitDateParts from '../../helpers/split-date-parts';

/**
 * @public
 * Validates if the field value is a valid date.
 *
 * @param  {Element} field: The element holding the date value.
 * @param  {Object} ruleConfig: Configuration to the rule.
 * @return {Boolean} Indicates wether the value is a valid date or not.
 */
export default function date({field, value, message}) {
  const validFormat = /^\d{2}\/\d{2}\/\d{4}$/.test(value) || /^\d{4}-\d{2}-\d{2}$/.test(value);
  if (!validFormat) {
    return {
      field,
      isValid: false,
      message,
    };
  }

  // Parse the date parts to integers
  const {month, day, year} = splitDateParts(value);

  // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month === 0 || month > 12) {
    return {
      field,
      isValid: false,
      message,
    };
  }

  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
    monthLength[1] = 29;
  }

  // Check the range of the day
  if (day > 0 && day <= monthLength[month - 1]) {
    return {
      field,
      isValid: true,
    };
  }

  return {
    field,
    isValid: false,
    message,
  };
}
